import { Button, Clickable, Strong } from '@ahmdigital/ui';
import styled from 'styled-components';

import NavigationHeaderTitle from '../navigation-header-title';
import PriceDisclaimer from '../../../price-disclaimer';

export const MobileWrapper = styled.div`
  margin-top: -17rem;
  margin-left: -2rem;
  padding: 18rem 0 0;
  width: calc(100% + 3rem);
`;

export const StyledDisclaimer = styled(PriceDisclaimer)`
  color: ${({ theme }) => theme.colors.grey70};
  max-width: 54rem;
  padding: 0 1.25rem;
  text-align: center;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    color: ${({ theme }) => theme.colors.white};
    padding: 0;
  }
`;

export const StyledFindClickable = styled(Clickable)`
  color: ${({ theme }) => theme.colors.white};
  margin: 0.75rem;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin: 0;
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-left: 1rem;
  }
`;

export const StyledNavigationHeaderTitle = styled(NavigationHeaderTitle)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    display: inline;
  }
`;

export const StyledStrong = styled(Strong)`
  display: inline-block;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 2rem;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    align-items: center;
    display: flex;
    margin-bottom: 1rem;
    justify-content: center;
  }
`;

export const FilterBarWrapper = styled.div<{ isProductPage: boolean }>`
  margin-top: ${({ isProductPage }) => (isProductPage ? '0rem' : '-0.5rem')};
  text-align: center;
  z-index: 999;
`;

export const GridColumns = styled.div`
  grid-column: 2 / span 4;
  background-color: ${({ theme }) => theme.colors.black};
  margin-top: -0.5rem;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  display: block;
  margin-top: 0;
`;
